import { UserIcon } from 'vlab-frontend-components'
import { phoneMask } from '../../utils/masks'
import { useTranslation } from 'react-i18next';

interface IFeedbackCard {
    feedbacks: {
        created_at: string
        feedback: string
        name: string
        cellphone: string
        profile_picture?: string
    }[]
    containerClassName?: string
}

function FeedBackCard({ feedbacks, containerClassName}: IFeedbackCard) {
    const { t } = useTranslation();
    const dateFormatOptions: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    };

    return (
        <div className={`p-6 bg-[#F7F8FC] w-full rounded text-[12px] h-full ${containerClassName}`}>
            <div className="flex flex-row lg:flex-col gap-4 lg:items-center items-start h-full">
                {feedbacks.map((feedback) => {
                    const date = new Date(feedback.created_at).toLocaleDateString(
                        document.documentElement.lang,
                        dateFormatOptions
                    );

                    return (
                        <div className="w-[350px] min-w-[350px] lg:min-w-[100%] justify-between flex flex-col lg:flex-row gap-3 lg:gap-6 px-4 py-3 lg:px-6 lg:py-4 bg-white rounded items-center lg:w-full leading-4">
                            <div className="flex items-center gap-4 w-full lg:w-[200px]">
                                <div className="w-[32px] h-[32px] min-w-[32px] rounded-full overflow-hidden flex items-center justify-center bg-[#ECF2F8]">
                                    {feedback.profile_picture ? (
                                        <img 
                                            src={feedback.profile_picture}
                                            alt={feedback.name}
                                            className="w-full h-full object-cover"
                                            onError={(e) => {
                                                e.currentTarget.style.display = 'none';
                                                const fallbackDiv = e.currentTarget.parentElement?.querySelector('div:last-child');
                                                if (fallbackDiv) fallbackDiv.className = 'block';
                                            }}
                                        />
                                    ) : null}
                                    <div className={feedback.profile_picture ? 'hidden' : 'block'}>
                                        <UserIcon width="16px" height="16px" color="#0166FF" />
                                    </div>
                                </div>
                                <div className="m-0 flex-shrink min-w-0">
                                    <p className="font-semibold text-[16px] text-[#51525F] overflow-hidden text-ellipsis whitespace-nowrap w-[150px]" title={feedback.name}>{feedback.name}</p>
                                    <p className="text-[10px] w-[100px] mt-1 text-[#8B98A3] leading-[120%] font-normal">{phoneMask(feedback.cellphone)}</p>
                                </div>
                            </div>

                            <p className="w-full max-w-[100% - 48px] text-[#51525F] leading-[120%] lg:leading-[140%] text-[12px] font-normal">“{feedback.feedback}”</p>

                            <div className="flex gap-6 items-center self-start lg:self-center">
                                <div className="h-[32px] w-[1px] bg-[#DDE5EC] hidden lg:block" />
                                <p className="text-[10px] text-[#8B98A3] min-w-[120px] text-left lg:text-center leading-[120%] font-normal">{date}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default FeedBackCard
